export interface PlanDetails {
  id: string;
  name: string;
  price: number;
  description: string;
  features: string[];
  originalPrice?: number;
  discount?: number;
}
export const plans: { [key: string]: PlanDetails } = {
  digital: {
    id: "digital",
    name: "DIGITAL",
    price: 99000,
    description: "경제적인 시작으로 디지털 스토리북 경험",
    features: ["AI 인터뷰 10회", "AI 스토리북 편집", "디지털 북 제공", "이메일 지원"],
  },
  premium: {
    id: "premium",
    name: "PREMIUM",
    price: 299000,
    originalPrice: 399000,
    discount: 25,
    description: "고퀄리티 스토리북 제작 희망",
    features: [
      "AI 인터뷰 20회",
      "전문 에디터 편집",
      "디지털 북 제공",
      "하드커버 책 2권 제공",
      "음성/영상 스토리북(옵션)",
      "우선 지원",
    ],
  },
  enterprise: {
    id: "enterprise",
    name: "ENTERPRISE",
    price: 0,
    description: "기업/복지관/요양시설 전용",
    features: [
      "맞춤형 견적문의",
      "기업 및 기관 전용 상품 구성",
      "계약 규모에 따른 할인 제공",
      "오프라인 수업 제공(오픈 예정)",
      "전담 매니저 지원",
    ],
  },
};

export const FooterLink = {
  service: [
    // {
    //   name:`비즈니스 문의`,
    //   link:``,
    // },
    {
      name: `상품 구매하기`,
      type: "order",
      link: `/order?planId=premium`,
    },
    {
      name: `앱 다운로드`,
      type: "url",
      link: `https://play.google.com/store/apps/details?id=kr.co.utopsoft.vcall&pcampaignid=web_share`,
    },
  ],
  cscenter: [
    // {
    //   name:`자주 묻는 질문`,
    //   link:``,
    // },
    {
      name: `1:1문의`,
      link: `/contact`,
    },
  ],
  policy: [
    {
      name: `서비스 이용 약관`,
      link: `policy`,
    },
    {
      name: `개인 정보 처리 방침`,
      link: `privacy`,
    },
    {
      name: `환불 정책`,
      link: `refund`,
    },
  ],
};
// order.tsx 선물용 상품 안내 문구
export const giftProcInfo: any = [
  {
    question: `Q. 선물용은 무엇이 다른가요?`,
    answer: `선물용 상품은 쿠폰 코드 형식으로 발송됩니다. 선물 받은 사람은 기억의 서랍에서 쿠폰 코드를 입력 후 서비스를 사용하실 수 있습니다.`,
  },
  {
    question: `Q. 선물 받을 사람이 회원이어야 하나요?`,
    answer: `선물 받으실 분은 현재 회원 가입된 상태가 아니어도 괜찮습니다. 이후에 회원 가입 및 쿠폰 코드 등록 후 스토리북을 시작하실 수 있습니다.`,
  },
  {
    question: `Q. 선물 받을 사람이 스스로 등록할 수 있나요?`,
    answer: `네, 선물 상품 구매 후 받으실 분의 전화번호를 입력해주시면 받으실 분의 번호로 쿠폰 코드와 가입 안내를 보내드립니다.`,
  },
  {
    question: `Q. 선물 받을 사람의 휴대폰 번호를 몰라요.`,
    answer: `선물 받을 사람의 휴대폰 번호를 몰라도, 구매자 분의 휴대폰 번호로 쿠폰 코드와 가입 안내를 받아서 이후에 직접 전달해드릴 수 있습니다. 쿠폰 코드는 기억의 서랍 웹사이트 내 [마이페이지]의 [내가 선물한 쿠폰]에서 언제든지 확인할 수 있습니다.`,
  },
  {
    question: `Q. 이용 기간은 바로 시작되나요?`,
    answer: `서비스 이용 기간에는 쿠폰 구매일이 아닌 쿠폰 코드 등록일로부터 계산되니 안심하세요.`,
  },
  {
    question: `Q. 쿠폰 코드 등록은 언제까지 할 수 있나요?`,
    answer: `구매일로부터 90일 내로 쿠폰 코드를 등록해 주세요.`,
  },
];

export const phoneNumFix = (number: string) => {
  let res = ``;
  if (number) {
    res = `${number?.slice(0, 3)}-****-${number?.slice(7, 11)}`;
  }
  return res;
};
export const emailFix = (email: string) => {
  let res = ``;
  if (email) {
    let txt = email.split(`@`);
    res = `${txt[0].slice(0, 1)}${txt[0].slice(1).replace(/./g, "*")}@${txt[1]}`;
    console.log(res);
  }
  return res;
};

export const providerType = (type: string) => {
  let res: any = {};
  if (type === `kakao`) {
    res = {
      name: `카카오`,
      path: `../../assets/icons/login_kakao.png`,
    };
  }
  if (type === `google`) {
    res = {
      name: `구글`,
      path: `../../assets/icons/login_google.png`,
    };
  }
  if (type === `apple`) {
    res = {
      name: `애플`,
      path: `../../assets/icons/login_apple.png`,
    };
  }
  return res;
};

export const formatTime = (seconds: number) => {
  // const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  // 두 자리로 맞추기 (padStart)
  // const hh = String(h).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");

  return `${mm}:${ss}`;
};

export const kwaFormat = (price: number | undefined) => {
  // 원화로 변경
  let res;
  if (price !== undefined && price !== null) {
    res = price.toLocaleString("ko-KR");
  }
  return res;
};

/**
 * 숫자를 1000단위로 쉼표로 구분하여 표시하는 함수
 * @param num - 포맷팅할 숫자
 * @returns 쉼표로 구분된 문자열
 */
export const formatNumber = (num: number | string | undefined): string => {
  if (num === undefined || num === null) return null as any;

  const number = typeof num === "string" ? parseFloat(num) : num;
  console.log("🚀 ~ formatNumber ~ number:", number);

  if (isNaN(number)) return null as any;

  return number.toLocaleString("ko-KR");
};

/**
 * HTML 태그를 제거하고 순수 텍스트만 반환하는 함수
 * @param html - HTML 문자열
 * @returns HTML 태그가 제거된 순수 텍스트
 */
export const stripHtmlTags = (html: string | undefined): string => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
};

/**
 * HTML 태그를 이스케이프하여 안전하게 표시하는 함수
 * @param html - HTML 문자열
 * @returns 이스케이프된 HTML 문자열
 */
export const escapeHtml = (html: string | undefined): string => {
  if (!html) return "";
  return html
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

/**
 * HTML 문자열을 안전하게 렌더링할 수 있는 객체로 변환하는 함수
 * @param html - HTML 문자열
 * @returns dangerouslySetInnerHTML에 사용할 수 있는 객체
 */
export const createSafeHtml = (html: string | undefined) => {
  if (!html) return { __html: "" };
  return { __html: html };
};

export const paymentState = async (state: string) => {
  let res = `ng`;
  if (state) {
    if (state === `ISSUED`) {
      res = `주문서 발행`;
    }
    if (state === `PAID`) {
      res = `결제완료`;
    }
    if (state === `CANCELLED`) {
      res = `주문취소`;
    }
    if (state === `REJECTED`) {
      res = `결제거부`;
    }
    if (state === `REFUNDED`) {
      res = `환불`;
    }
  }
  return res;
};
export const processStateToNum = (state: string) => {
  let res = `신규`; // 신규
  if (state === `interview`) {
    // 인터뷰
    res = `인터뷰`;
  }
  if (state === `ebook_creating`) {
    // 전자책 생성중
    res = `전자책 생성중`;
  }
  if (state === `ebook_complete`) {
    // 전자책 생성 완료
    res = `전자책 생성 완료`;
  }
  if (state === `physical_edit`) {
    // 실물책 편집
    res = `실물책 편집`;
  }
  if (state === `printing`) {
    // 인쇄
    res = `인쇄`;
  }
  if (state === `delivery`) {
    // 배송
    res = `배송`;
  }
  if (state === `delivery_complete`) {
    // 배송완료
    res = `배송완료`;
  }
  return res;
};

export const answerColor = (type: any) => {
  let res: any = {
    color: ``,
    txt: ``,
  };

  if (type === false) {
    res = {
      color: "warning",
      txt: `답변대기`,
    };
  }
  if (type === true) {
    res = {
      color: "success",
      txt: `답변완료`,
    };
  }
  return res;
};

export const catValToTxt = (val: string) => {
  let res = ``;
  if (val === "0") {
    res = `계정`;
  }
  if (val === "1") {
    res = `결제/ 환불/ 배송`;
  }
  if (val === "2") {
    res = `오류 신고`;
  }
  if (val === "3") {
    res = `기타`;
  }
  return res;
};

export const FaqMock = [
  {
    title: `기억의 서랍은 어떤 서비스인가요?`,
    txt: `기억의 서랍은 인터뷰를 통해 나만의 스토리북을 만드는 서비스입니다. AI 인터뷰어가 대화를 이끌어주고, 답변 내용을 AI 편집자가 글로 완성합니다. 글재주가 없어도 손쉽게 누구나 책을 만들 수 있습니다.`,
  },
  {
    title: `쿠폰이 등록되지 않아요.`,
    txt: `쿠폰 등록 관련 어려움이 있으시면 ‘1:1 문의’를 통해 문의주세요. 문의 전에 쿠폰 코드의 대소문자가 정확한지, 쿠폰 사용 기한이 지나지는 않았는지 확인해 주세요. `,
  },
  {
    title: `앱을 꼭 설치해야 하나요?`,
    txt: `네, 기억의 서랍 상품 이용을 위해서는 앱 설치가 필수입니다. 쿠폰 등록 완료 후 앱 설치 링크를 문자로 보내드립니다.`,
  },
  {
    title: `쿠폰 등록 후 서비스 이용 과정이 궁금해요.`,
    txt: `기억의 서랍 앱 로그인 후 매일 10분씩 약 3주 동안 인터뷰를 진행해 주세요. 모든 인터뷰를 완료하면 전자책을 신청할 수 있습니다. 전자책 내용을 확인하고, 마지막으로 실물책을 신청해주시면 10~13일 후 실물책을 받아보실 수 있어요.`,
  },
];

export const cscenterMockupList = [
  {
    ids: `0`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: false, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
  {
    ids: `1`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: true, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
  {
    ids: `2`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: true, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
  {
    ids: `3`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: true, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
  {
    ids: `4`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: true, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
  {
    ids: `5`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: true, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
  {
    ids: `6`,
    subject: `인터뷰가 안돼요 인터뷰가 안돼요 인터뷰가 안돼요 인`, // 제목
    user_upload_date: `2025.07.26`, // 유저 등록일
    answer_upload_date: `2025.08.13`, // 관리자 답변등록일
    description: `궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요. 궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.궁금한 점이 있어서 문의 남겨요.`, // 내용
    comment: `안녕하세요, 기억의 서랍입니다.문의 주셔서 감사합니다.환불 진행 도와드리겠습니다.2-3일 내로 취소 처리될 예정입니다.감사합니다.`, // 답변내용
    answer: true, // 답변여부
    images: [
      // 이미지 리스트
      ``,
      ``,
    ],
  },
];


export const sendVerificationCode = async (phoneNumber:any,kuid:any) => {
  let res:any = 'ng'
  if (!phoneNumber) {
    res = '전화번호를 입력해주세요.';
    return res;
  }
  console.log(phoneNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, '$1-$2-$3'));
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sms/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone_number: phoneNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, '$1-$2-$3'),
        kuid: kuid
      })
    });
    
    const data = await response.json();
    
    if (response.ok && data.success) {
      res = {
        success:data?.success,
        sessionId:data?.sessionId
      }
    } else {
      res = '인증코드를 받는데 실패했습니다.';
    }
    return res;
  } catch (error:any) {
    alert(error?.message);
  }
};


export const verifyCode = async (phoneNumber:any,phoneCode:any,sessionId:any) => {
  let res:any = 'ng'
  if (!phoneCode) {
    res = `ng`
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sms/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
        verification_code: phoneCode.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, '$1-$2-$3'),
        session_id: sessionId
      })
    });
    const data = await response.json();
    if (response.ok && data.success) {
      // 전화번호 인증 완료 처리
      // await completePhoneVerification();
      res = 'ok';
    }
    return res;
  } catch (error:any) {
    alert(error?.message)
  }
};

export const resendCode = async (phoneNumber:any,kuid:any) => {
  let res:any = 'ng';
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sms/resend`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone_number: phoneNumber,
        // session_id: sessionId,
        kuid:kuid,
      })
    });
    
    const data = await response.json();
    
    if (response.ok && data.success) {
      res = {
        success:data?.success,
        sessionId:data?.session_id
      };
      return res;
    }
  } catch (error:any) {
    alert(error?.message);
  }
};